import React, { useState } from 'react'
import 'firebase/compat/functions'
import { Box, Grid, Paper } from '@mui/material'
import betalningsmetoder from '../media/betalningsmetoder-footer.webp'

import { useTranslation } from 'react-i18next'

//   <label  onClick={() => {window.open("https://www.facebook.com/profile.php?id=100090693737485")}} style={{color: "black", cursor: "pointer"}}><FacebookIcon/>Facebook</label>
//                 <label onClick={() => {window.open("https://www.instagram.com/halkan.se/")}}  style={{color: "black", cursor: "pointer"}}><InstagramIcon/>Instagram </label>
export default function Footer () {
  const { t } = useTranslation()
  const [cookies, setCookies] = useState(false)
  const [tos, setTos] = useState(false)
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        maxWidth: '100vw',
        alignItems: 'flex-end'
      }}
    >
      {tos === true && <TOS />}
      {cookies === true && <Cookies />}
      <Grid
        container
        spacing={2}
        sx={{
          backgroundColor: '#f2f9fe',
          alignItems: 'center',
          padding: 2,
          paddingRight: { xl: '20vw' },
          paddingLeft: { xl: '20vw' }
        }}
      >
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', md: 'flex-start' }
          }}
        >
          <label>Halkan.se | 2023</label>
          <label>
            Telefonnummer: <a href='tel:+46737293293'>0737 293 293</a>{' '}
          </label>
          <label>info@halkan.se</label>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', md: 'flex-end' }
          }}
        ></Grid>
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            display: 'flex',
            alignContent: { xs: 'center', md: 'flex-end' },
            justifyContent: { xs: 'center', md: 'flex-end' }
          }}
        >
          <img
            alt={'Betalningsmetoder'}
            src={betalningsmetoder}
            style={{ maxWidth: 300 }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            maxHeight: 'fit-content',
            marginTop: 0,
            paddingTop: 0,
            display: 'flex',
            flexDirection: { md: 'row', xs: 'column' },
            gap: 2
          }}
        >
          <i
            onClickCapture={() => {}}
            style={{
              color: 'black',
              textDecoration: 'underline',
              fontSize: 10,
              cursor: 'pointer'
            }}
            onClick={() => setTos(true)}
          >
            {t('footer.tos')}
          </i>

          <i
            onClickCapture={() => {}}
            style={{
              color: 'black',
              textDecoration: 'underline',
              fontSize: 10,
              cursor: 'pointer'
            }}
            onClick={() => setCookies(true)}
          >
            {t('footer.cookies')}
          </i>
        </Grid>
      </Grid>
    </Box>
  )

  function TOS () {
    return (
      <div
        style={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'fixed',
          zIndex: 1000,
          backgroundColor: 'rgba(0,0,0,0.56)',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Paper
          style={{
            height: 'fit-content',
            maxHeight: '80dvh',
            width: '80vw',
            overflowY: 'scroll',
            padding: 10
          }}
        >
          <div style={{ display: 'flex', width: '100%' }}>
            <h5 style={{ textAlign: 'left', fontWeight: 'bold', flex: 1 }}>
              {t('footer.tos')}
            </h5>
            <h4
              onClick={() => setTos(false)}
              style={{ textAlign: 'right', flex: 1, cursor: 'pointer' }}
            >
              x
            </h4>
          </div>
          <h5 style={{ textAlign: 'left', fontWeight: 'bold' }}>
            Leveransvillkor / Boknings- och leveransinformation
          </h5>
          <p>
            Köp av körkortskurser avser en tjänst. Efter genomfört köp får
            kunden en bokningsbekräftelse via e-post. Kunden ansvarar för att
            ange korrekta kontaktuppgifter. Leveransen av tjänsten sker på den
            kursdag och tid som kunden valt, eller enligt senare
            överenskommelse.
          </p>
          <p>
            Om en kurs ställs in av oss (t.ex. på grund av lärarbrist eller
            sjukdom) erbjuds kunden en ny tid eller full återbetalning. Vi
            ansvarar inte för kostnader som uppstår utöver kursavgiften,
            exempelvis resor eller logi.
          </p>

          <h5 style={{ textAlign: 'left', fontWeight: 'bold' }}>
            Reklamation av tjänst
          </h5>
          <p>
            Kunden har rätt att reklamera en tjänst enligt konsumenttjänstlagen
            om tjänsten är felaktigt utförd eller inte motsvarar vad som
            utlovats. Ett exempel på fel i tjänsten kan vara om kunden har bokat
            transport till halkbanan som en del av kursen, men denna transport
            inte tillhandahålls som utlovat. Reklamation ska göras till vår
            kundtjänst på info@halkan.se så snart kunden upptäcker felet, och
            inom skälig tid.
          </p>
          <p style={{ marginBottom: 0 }}>
            Godkända reklamationer kan leda till:
          </p>
          <ul style={{ textAlign: 'justify', marginTop: 0 }}>
            <li>ombokning av kurs,</li>
            <li>prisavdrag, eller</li>
            <li>
              återbetalning, beroende på vad som är rimligt i det aktuella
              fallet.
            </li>
          </ul>
          <p>
            Observera att frånvaro eller sen ankomst inte räknas som fel i
            tjänsten och ersätts därför inte.
          </p>

          <h5 style={{ textAlign: 'left', fontWeight: 'bold' }}>Tvister</h5>
          <p>
            Vi strävar efter att lösa eventuella tvister direkt med kunden. Om
            tvist inte kan lösas genom dialog kan kunden vända sig till Allmänna
            reklamationsnämnden (ARN) för prövning. Vi följer ARN:s
            rekommendationer. Tvister kan slutligen prövas av allmän domstol i
            Sverige.
          </p>

          <h5 style={{ textAlign: 'left', fontWeight: 'bold' }}>
            Integritetspolicy
          </h5>
          <h5 style={{ textAlign: 'left', fontWeight: 'bold' }}>
            Personuppgiftsansvarig
          </h5>
          <p>
            Vi är personuppgiftsansvariga för behandlingen av de personuppgifter
            du lämnar i samband med bokning av våra körkortskurser. Som
            personuppgiftsansvariga säkerställer vi att dina uppgifter hanteras
            i enlighet med gällande dataskyddslagstiftning, inklusive GDPR.
          </p>
          <p style={{ marginBottom: 0 }}>
            Personuppgifter används exempelvis för:
          </p>
          <ul
            className='list-disc'
            style={{ marginTop: 0, listStyle: 'inside' }}
          >
            <li>bokning och genomförande av kurser,</li>
            <li>rapportering av utbildningar till Transportstyrelsen,</li>
            <li>kundservice och betalningshantering.</li>
          </ul>
        </Paper>
      </div>
    )
  }

  function Cookies () {
    return (
      <div
        style={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'fixed',
          zIndex: 1000,
          backgroundColor: 'rgba(0,0,0,0.56)',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Paper
          style={{
            height: '80vh',
            width: '80vw',
            overflowY: 'scroll',
            padding: 10
          }}
        >
          <div style={{ display: 'flex', width: '100%' }}>
            <h2 style={{ textAlign: 'left', flex: 1, fontWeight: 'bold' }}>
              {t('footer.cookies')}
            </h2>
            <h4
              onClick={() => setCookies(false)}
              style={{ textAlign: 'right', flex: 1, cursor: 'pointer' }}
            >
              x
            </h4>
          </div>
          <h3 style={{ fontWeight: 'bold', textAlign: 'center' }}>
            Cookies Policy
          </h3>
          <br />
          <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>
            {' '}
            Användning av nödvändiga cookies{' '}
          </h5>
          <p>
            Vi använder endast nödvändiga cookies på vår webbplats för att
            säkerställa att den fungerar korrekt och för att förbättra din
            användarupplevelse. Dessa cookies lagrar information om ditt besök,
            såsom dina språkinställningar, och är avgörande för webbplatsens
            grundläggande funktioner. De kan inte användas för
            marknadsföringsändamål och samlar inte in personlig information.
            Genom att använda vår webbplats samtycker du till användningen av
            dessa nödvändiga cookies.
          </p>
          <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>
            Användning av Google Analytics-cookies och Google Tag Manager
          </h5>
          <p>
            Vi använder även tredjepartscookies från Google Analytics för att
            samla in information om hur besökare interagerar med vår webbplats.
            Denna data hjälper oss att förstå besöksmönster och förbättra vår
            webbplats löpande. Google Analytics-cookies samlar inte in personlig
            information, utan endast anonymiserad data såsom geografisk plats,
            webbläsare, enhetstyp och vilka sidor som besökts.
          </p>
          <p>
            För att hantera cookie-samtycke använder vi Usercentrics, som
            implementeras via Google Tag Manager (GTM). GTM används också för
            att styra vilka cookies och marknadsföringsverktyg som aktiveras
            baserat på ditt samtycke. Detta innebär att inga analys- eller
            marknadsföringscookies laddas innan du har gett ditt godkännande.
          </p>
          <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>
            Hantering av cookies i din webbläsare
          </h5>
          <p>
            Du kan blockera eller radera cookies genom att ändra inställningarna
            i din webbläsare. Observera dock att om du blockerar cookies kan
            vissa delar av vår webbplats sluta att fungera korrekt.   
            <h3 style={{ fontWeight: 'bold', textAlign: 'center' }}>
              {' '}
              Privacy Policy
            </h3>
            Vår åtagande för att skydda din integritet Vi värnar om din
            integritet och behandlar all data som samlas in från vår webbplats
            med stor försiktighet.
          </p>
          <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>
            {' '}
            Hantering av personuppgifter
          </h5>
          <p>
            Vi säljer eller delar inte din personliga information med tredje
            part. Vi sparar dina uppgifter endast så länge som det är nödvändigt
            för att uppfylla våra åtaganden gentemot dig som kund och i enlighet
            med tillämpliga lagar och förordningar.
          </p>
          <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>
            Säkerhet av personuppgifter
          </h5>
          <p>
            Vi använder lämpliga tekniska och organisatoriska säkerhetsåtgärder
            för att skydda dina personuppgifter mot obehörig åtkomst, missbruk,
            förlust eller ändring. Vi skyddar din personliga information genom
            att använda säkra protokoll för dataöverföring och lagring.
          </p>
          <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>
            {' '}
            Information som samlas in vid bokning
          </h5>
          <p>
            Vi samlar in följande information om dig när du gör en bokning på
            vår webbplats: ditt namn, din adress, ditt telefonnummer, ditt
            personnummer och din e-postadress. Denna information används för att
            kunna genomföra din bokning och för att skicka information om
            bokningen till dig.
          </p>
        </Paper>
      </div>
    )
  }
}
